/**
 * The application mark.
 *
 * The same shape as the installed icon — a check over the brand blue with an accent underline —
 * so the rail, the project list, and the home-screen icon read as one product.
 */

import type { ReactNode } from 'react';

/** Renders the mark at `size` pixels square. */
export function Brandmark({ size = 28 }: { size?: number }): ReactNode {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 512 512"
      aria-hidden="true"
      focusable="false"
      className="shrink-0"
    >
      <rect width="512" height="512" rx="112" fill="var(--color-brand)" />
      <path
        d="M136 268 214 346 380 180"
        fill="none"
        stroke="var(--color-on-brand)"
        strokeWidth="56"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="136" y="396" width="240" height="28" rx="14" fill="var(--color-accent)" />
    </svg>
  );
}
